import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/tipo-de-aplicaciones-de-tarifas-vehiculares/';

/**
 * GET Tipos de Aplicaciónes de Tarifas Vehiculares
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeAplicacionesDeTarifasVehiculares = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Aplicación de Tarifas Vehiculares
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeAplicacionDeTarifaVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Aplicación de Tarifas Vehiculares
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeAplicacionDeTarifaVehicular = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Aplicación de Tarifas Vehiculares
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeAplicacionDeTarifaVehicular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Aplicación de Tarifas Vehiculares
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeAplicacionDeTarifaVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
